<template>
  <!--版本信息、颜色-->
  <div class="sku-specs" v-if="spuInfo && spuInfo.specItem && (spuInfo.specItem.specMain || []).length">
    <section class="layer-section" v-for="(specId, index) in specMain" :key="index">
      <h3 class="section-title">
        <span class="tit">{{ specMainSeq[specId] }}</span>
        <span class="hint" v-show="!checkedSpecItem[specId] || !checkedSpecItem[specId].id">
          *请选择{{ specMainSeq[specId] }}
        </span>
      </h3>
      <div class="section-content version">
        <template v-for="(specItem, idx) in specItemSeq[specId]">
          <div class="btn-wrapper" :key="'idx' + idx">
            <div
              :class="{
                'section-btn': true,
                disabled: isDisabled(specId, idx + 1),
                none: isDashed(specId, idx + 1),
                checked: checkedSpecItem[specId].id - 1 === idx && !isDisabled(specId, idx + 1)
              }"
              @click="selectSpecItem(specId, idx + 1, specMainSeq[specId], specItem.name)"
            >
              <p class="name">{{ specItem.name }}</p>
            </div>
          </div>
        </template>
      </div>
    </section>
  </div>
</template>

<script>
import getAvaiSpecs from './spec'

export default {
  name: 'sku-specs',
  props: ['operateType', 'spuInfo', 'defaultSkuId', 'specMain', 'specMainSeq', 'skuSpecList', 'specItemSeq', 'skuId'],
  data() {
    return {
      oldSkuId: '',
      // 记录已选中的规格项， 形如{0: {id: 1, name: '全网通64g'}}的形式
      checkedSpecItem: {},
      // 选中的sku的规格项名称组合，如果当前选中的规格项不能组成sku，则为上一个sku的规格项组合
      skuSpecName: ''
    }
  },
  computed: {
    skuMap() {
      const map = {}

      this.skuSpecList.forEach(sku => {
        const specItemIds = this.specMain.map(specId => sku.sequences[specId]).join('-')
        map[specItemIds] = sku.skuId
      })

      return map
    },
    // 有库存的skulist
    storeSkuSpecList() {
      return this.skuSpecList.filter(item => {
        return !this.noStoreSku.includes(item.skuId)
      })
    },
    // 缺货，下架的skuList
    noStoreSku() {
      // 拼购商品不会有下架和无库存sku，接口会过滤
      if (this.operateType == 2) {
        return []
      }
      return this.spuInfo.zeroStoreSkuIds.concat(this.spuInfo.downSkuIds)
    },
    // 通过sku算法，算出每一个规格项的可选状态
    availableSpecItems() {
      const param = this.specMain.map(specId => this.checkedSpecItem[specId].id || '')

      return this.chooseSpec(param, this.skuSpecList)
    },
    // 通过sku算法，算出每一个有库存规格项的可选状态
    storeSpecItems() {
      const param = this.specMain.map(specId => this.checkedSpecItem[specId].id || '')

      return this.chooseSpec(param, this.storeSkuSpecList)
    }
  },
  watch: {
    skuId(skuId) {
      // 如果skuId不等于oldSkuId，重新初始化选中项
      if (this.oldSkuId != skuId) {
        this.oldSkuId = skuId
        this.initCheckedSpecs()
      }
    },
    // 检测规格项的变化，如果规格项变化后可以组成新的sku，则向上通报
    checkedSpecItem: {
      handler(val) {
        let specData = {
          oldSkuId: this.skuId,
          skuId: this.skuId,
          isSku: false,
          name: this.skuSpecName
        }

        if (this.isSku()) {
          const specItemIds = this.specMain.map(specId => this.checkedSpecItem[specId].id).join('-')
          const specItemText = this.specMain.map(specId => this.checkedSpecItem[specId].name).join(' ')

          this.skuSpecName = specItemText
          specData.skuId = this.skuMap[specItemIds]
          specData.name = specItemText
          specData.isSku = true
          // 更新oldSkuId
          this.oldSkuId = specData.skuId
        }
        this.$emit('skuChange', specData)
      },
      deep: true
    }
  },
  created() {
    this.initCheckedSpecs()
  },
  methods: {
    initCheckedSpecs() {
      // 初始化checkedSpecItem
      // 根据skuId找到对应的sku项
      const currentSku = this.skuSpecList.find(item => item.skuId == this.skuId)
      let skuSpecs = {}

      if (currentSku) {
        skuSpecs = currentSku.sequences
      }

      this.specMain.forEach(specId => {
        // 当前sku不存在的话，则选中项初始化为空值
        const specItemId = skuSpecs[specId] || ''
        let specItemName = ''
        if (specItemId) {
          specItemName = this.specItemSeq[specId][specItemId - 1].name
        }
        this.$set(this.checkedSpecItem, specId, {
          id: specItemId,
          name: specItemName
        })
      })
    },
    chooseSpec(checkedSpecItemIds, skuList) {
      return getAvaiSpecs(checkedSpecItemIds, skuList, this.specMain, this.specItemSeq, this.specMainSeq)
    },
    selectSpecItem(specId, specItemId, specName, specItemName) {
      // 向上通报规格项点击事件
      this.$emit('specItemClick', {
        specName,
        specItemName
      })
      if (this.isDisabled(specId, specItemId)) {
        return
      }

      // 如果是第一规格项，且不能组成SKU，需要清除已选择的规格项
      const specIndex = this.specMain.indexOf(specId)
      if (this.isFirstSpec(specId) && this.availableSpecItems[specIndex].indexOf(specItemId + '') < 0) {
        this.specMain.forEach(specId => {
          this.checkedSpecItem[specId] = this.isFirstSpec(specId)
            ? {
                id: specItemId,
                name: this.specItemSeq[specId][specItemId - 1].name
              }
            : ''
        })
      } else {
        // 记录选中的规格项
        this.checkedSpecItem[specId] = {
          id: specItemId,
          name: this.specItemSeq[specId][specItemId - 1].name
        }
      }
    },
    // 该规格是否不可选,该状态不能加载第一规格项上
    isDisabled(specId, specItemId) {
      const index = this.specMain.indexOf(specId)
      return !this.isFirstSpec(specId) && this.availableSpecItems[index].indexOf(specItemId + '') < 0
    },

    // 该规格项是否是下架或无货,该状态不能加载第一规格项上
    isDashed(specId, specItemId) {
      const index = this.specMain.indexOf(specId)
      // 该规格项不是第一规格项，且该规格项是可选规格项，且规格项不为有库存规格项 才加下架缺货状态
      return (
        !this.isFirstSpec(specId) &&
        this.availableSpecItems[index].indexOf(specItemId + '') >= 0 &&
        this.storeSpecItems[index].indexOf(specItemId + '') < 0
      )
    },

    // 根据已选的规格项判断是否能组成完整的sku
    isSku() {
      return this.specMain.every(specId => !!(this.checkedSpecItem[specId] && this.checkedSpecItem[specId].id))
    },

    // 判断某个规格项是否是第一规格项，缺货和不可选状态不能加到第一规格项上
    isFirstSpec(specId) {
      // 规格项有多个，且该规格项为第一个，则为第一规格项
      if (this.specMain.length > 1 && this.specMain[0] == specId) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
